export const COLLECTION_TYPES = {
    scenes: 'scenes',
    players: 'players',
};
